import React from 'react'
import Tag from '../Tag'
import QuizProvider from '../Quiz/Service/QuizProvider'
import SocialSharing from "../SocialSharing"
import classNames from "classnames"

class ModalFactContentContainer extends React.Component {
  render() {
    let quiz = this.props.quiz
    let {isProtectQuiz, startProtectQuiz} = this.props

    return (
      <div className={classNames({'no-right' : isProtectQuiz && startProtectQuiz}, 'fact-content')}>
        { isProtectQuiz && startProtectQuiz ? '' :
          <Tag
            {...this.props}
            tagId={this.props.data.tag}
            title={this.props.data.tagName}
          />
        }
        { quiz ?
          <>
            { isProtectQuiz && startProtectQuiz ?
              ''
              :
              <Tag
                {...this.props}
                tagId="quiz"
                title="тест"
              />
            }
            <QuizProvider
              {...this.handlers}
              {...this.props}
              {...this.state}
              quiz={ quiz } isProtectQuiz={ isProtectQuiz } startProtectQuiz={ startProtectQuiz }/>
          </>
          :
          <>
            <div
              className="title"
              dangerouslySetInnerHTML={{ __html: this.props.data.title }}
            />

            <div
              className="description"
              dangerouslySetInnerHTML={{ __html: this.props.data.description }}
            />

            <SocialSharing
              mainText={this.props.data.description}
            />
          </>
        }
      </div>
    )
  }
}

export default ModalFactContentContainer
